<template>
  <v-simple-table dense>
    <template v-slot:default>
      <!-- <thead>
        <tr>
          <th class="font-weight-bold">{{ $t('gen.name') }}</th>
          <th class="text-right">{{ $t('gen.amount') }}</th>
        </tr>
      </thead> -->
      <tbody>
        <!-- Raw cost: one row per renter -->
        <template v-if="isShowRawCost">
          <tr
            v-for="(renterPaid, renter) in tr.rentersPaid"
            :key="renter"
            :class="renterRowClass(renter)"
          >
            <td class="px-1">{{ renter }}</td>
            <td class="px-1 text-right">
              {{ generateTextAmount(renter) }}
            </td>
          </tr>
        </template>

        <!-- Collapsed: group renters with the same amount -->
        <template v-else>
          <tr
            v-for="(group, i) in collapsedRenterGroups"
            :key="i"
            :class="renterRowClass(group.renters.find((r) => r === user))"
          >
            <td class="px-0">
              <v-chip
                v-for="renter in group.renters"
                :key="renter"
                small
                outlined
                class="ma-1 ml-0 px-2"
                :class="renterChipClass(renter)"
              >
                {{ renter }}
              </v-chip>
            </td>
            <td class="px-1 text-right">
              <span v-if="group.renters.length > 1" class="black--text">
                {{ group.renters.length }} ×
              </span>
              {{ group.amountText }}
            </td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { isRenterCompletePaid, isRenterPaid } from "@/service/transaction.utils.js";

export default {
  props: {
    tr: {
      type: Object,
      required: true,
    },
    renterCosts: {
      type: Object,
      required: true,
    },
    user: {
      type: String,
      default: "",
    },
    showAmountDetail: {
      type: Boolean,
      default: false,
    },
    isShowRawCost: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    collapsedRenterGroups() {
      const groupsByKey = {};

      Object.keys(this.tr.rentersPaid || {}).forEach((renter) => {
        const amountText = this.generateTextAmount(renter);
        // Group only by amount text so equal splits (and owners) collapse together
        const key = amountText;

        if (!groupsByKey[key]) {
          groupsByKey[key] = {
            renters: [],
            amountText,
          };
        }
        groupsByKey[key].renters.push(renter);
      });

      return Object.values(groupsByKey);
    },
  },

  methods: {
    isRenterCompletePaid,
    isRenterPaid,

    isRenterPayer(renter) {
      return (this.tr.payers || []).some((p) => p.payer === renter);
    },

    renterRowClass(renter) {
      if (!renter || renter !== this.user) return {};
      return {
        "text--darken-1 font-weight-black": true,
        "error--text": !isRenterCompletePaid(this.tr, renter),
        "success--text": isRenterCompletePaid(this.tr, renter),
      };
    },

    renterChipClass(renter) {
      if (renter !== this.user) return {};
      return {
        "font-weight-black": true,
        error: !isRenterCompletePaid(this.tr, renter),
        success: isRenterCompletePaid(this.tr, renter),
      };
    },

    generateTextAmount(renter) {
      if (!Object.keys(this.renterCosts[renter] || {}).length) {
        return this.isRenterPayer(renter) ? `(${this.$tc("gen.payer")})` : "-";
      }

      const totalAmount = Object.values(this.renterCosts[renter]).reduce((acc, curr) => acc + curr, 0).toFixed(2);
      if (!this.showAmountDetail) {
        return totalAmount;
      }

      // return: 30 (Joe) + 20 (John) = 50 THB
      return Object.entries(this.renterCosts[renter]).map(([payer, amount]) => `${amount.toFixed(2)} (${payer})`).join(" + ") + ` = ${totalAmount}`;
    },
  }
};
</script>
